import { Field } from "formik";
import { DropdownToggle, Input, Label } from "reactstrap";
import styled from "styled-components";
import { DatePicker } from "antd";

export const CommonField = styled(Field)`
  padding: 8px;
  background: var(--gray-100);
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  box-shadow: none;
  height: calc(1.5em + 0.75rem + 2px);
  :focus {
    background: var(--gray-100);
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%);
  }
  > .is-invalid {
    background: red;
  }
`;
export const CommonDatePicker = styled(DatePicker)`
  padding: 8px;
  background: #ffff;
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  box-shadow: none;
  outline: 0;
  border-color: #b9bfc4 !important;
  height: calc(1.5em + 0.75rem + 2px);

  input::placeholder {
    font-size: 13px;
  }

  &:focus-within {
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%) !important;
  }

  :focus {
    border-color: #b9bfc4;
    border-width: 2px;
    background: var(--gray-100);
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%) !important;
  }

  :hover,
  :active {
    border-color: #b9bfc4;
    outline: 0;
  }
  > .is-invalid {
    background: red;
  }
`;
export const ContainerDatePicker = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;

  label {
    font-width: lighter;
    margin-top: 0;
    margin-right: 8px;
    white-space: nowrap;
  }
`;
export const CommonInputt = styled.input`
  padding: 8px;
  background: var(--gray-100);
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  box-shadow: none;
  height: calc(1.5em + 0.75rem + 2px);
  :focus {
    background: var(--gray-100);
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%);
  }
  > .is-invalid {
    background: red;
  }
  :disabled {
    background: var(--gray-100);
  }
`;

export const CommonLabel = styled(Label)`
  margin-bottom: var(--margin-xs);
  font-size: 12px;
  font-weight: 400;
`;

export const CommonDropdownToggle = styled(DropdownToggle)`
  background-color: var(--white);
  border-color: #f9fafa;
  box-shadow: var(--btn-shadow);
  color: var(--black);
  transition: all 0.2s ease;
  min-width: 38px;
  min-height: 38px;
  height: var(--btn-height);
  margin-left: var(--margin-sm, 8px);
  border-radius: var(--border-radius);
  font-size: var(--text-md);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  :hover,
  :active {
    background-color: var(--fg-color);
  }
`;

export const CommonSelect = styled.select`
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  border: 1px solid #ced4da;
  white-space: pre;
  padding: 8px;
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  box-shadow: none;
  width: 100%;
  min-width: 10rem;
  height: calc(1.5em + 0.75rem + 2px);
  background: var(--gray-100);
  :focus {
    background: var(--gray-100);
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%);
  }
  > .is-invalid {
    background: red;
  }
`;

export const CommonInput = styled(Input)`
  padding: 8px;
  background: var(--gray-100);
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  box-shadow: none;
  :focus {
    background: var(--gray-100);
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%);
  }
  > .is-invalid {
    background: red;
  }
`;
export const ComponentCheckbox = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelCheckbox = styled(CommonLabel)`
  margin: 0;
  padding-left: 6px;
`;

export const CommonTextarea = styled.textarea`
  padding: 8px;
  background: var(--gray-100);
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  box-shadow: none;
  :focus {
    background: var(--gray-100);
    box-shadow: 0 0 0 2px rgb(104 113 120 / 25%);
  }
  > .is-invalid {
    background: red;
  }
`;
